import React, { useState } from "react"
import ProtectedRoute from "../../routes/protected"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro"
import useCompanyData from "../../context/company"
import BirthdayCalendar from "./BirthdayCalendar"
import BirthdaySearch from "./BirthdaySearch"
import BirthdaySettings from "./BirthdaySettings"
import BirthdayReport from "./BirthdayReport"

const TABS = [
    { id: "calendar", label: "Calendário", icon: solid("calendar") },
    { id: "search", label: "Buscar", icon: solid("magnifying-glass") },
    { id: "report", label: "Relatório", icon: solid("chart-bar") },
    { id: "settings", label: "Configurações", icon: solid("gear") },
]

export default function BirthdaysModule() {
    const { rootUser } = useCompanyData()
    const [activeTab, setActiveTab] = useState("calendar")

    const tabs = TABS.filter(t => t.id !== "settings" || rootUser)

    return (
        <ProtectedRoute>
            <div className="container-fluid">
                <div className="row flex-nowrap">
                    <div className="col text-bg-green p-3 d-flex align-items-center flex-wrap gap-2">
                        <div className="d-flex align-items-center flex-wrap">
                            <a href="/painel/" className="fs-6 fw-bold ps-5 text-decoration-none text-white">
                                <FontAwesomeIcon icon={solid("arrow-left")} className="me-2" />
                                Aniversários
                            </a>
                            <span className="fs-6 fw-bold text-white ms-3 border-start border-white border-opacity-50 ps-3">
                                Calendário de Aniversários
                            </span>
                        </div>
                    </div>
                </div>

                <div className="my-4 mx-5 py-3 rounded-top">
                    <div className='d-flex align-items-center justify-content-between flex-wrap gap-2 mb-0'>
                    <ul className="nav nav-tabs px-3">
                                {tabs.map(tab => (
                                    activeTab === tab.id ? (
                                        <li key={tab.id} className="nav-item">
                                            <span className="nav-link active">
                                                {tab.label}
                                            </span>
                                        </li>
                                    ) : (
                                        <li key={tab.id} className="nav-item">
                                            <span
                                                className="nav-link text-green cursorPointer"
                                                onClick={() => setActiveTab(tab.id)}
                                            >
                                                {tab.label}
                                            </span>
                                        </li>
                                    )
                                ))}
                            </ul>
                    </div>
                    
                    <div className="bg-white py-4 rounded formMarginBottom" style={{minHeight: '500px'}}> 
                        <div className="px-4">
                            <div className="bg-white rounded border-clean p-4">
                                {activeTab === "calendar" && <BirthdayCalendar />}
                                {activeTab === "search" && <BirthdaySearch />}
                                {activeTab === "report" && <BirthdayReport />}
                                {activeTab === "settings" && rootUser && <BirthdaySettings />}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ProtectedRoute>
    )
}
